export default "__VITE_ASSET__DWfl8N8F__"